<div class="w-full grid grid-nogutter">
  <div class="col-12 lg:col-7 flex flex-column gap-2">
    <app-view-profile [studentId]="studentId" [isMentorView]="true" [canEdit]="false" [embedded]="true"></app-view-profile>
  </div>
  <div class="col-12 lg:col-5 pt-4 lg:pt-0 lg:pl-4">
    <app-additional-information-right-section [infoType]="infotype.Profile"></app-additional-information-right-section>
  </div>
</div>
